(function ($) {
  const mq = window.matchMedia('(min-width: 1025px)');

  function ajustar($item) {
    if (!mq.matches) return;

    const $menu = $item.closest('header .menu-content');
    const $panel = $item.find('.tb-megamenu-submenu').first();
    if (!$menu.length || !$panel.length) return;

    //Não aplicar width quando tiver submenu
    if (!$panel.find('.submenu-content').length) return;

    const menuRect = $menu[0].getBoundingClientRect();
    const itemRect = $item[0].getBoundingClientRect();

    const offsetLeft = itemRect.left - menuRect.left;
    const width = Math.max(0, menuRect.width - offsetLeft);

    $panel.css('max-width', width + 'px');
  }

  $(document).on('mouseenter focusin', 'header .tb-megamenu-item', function () {
    const $item = $(this);
    requestAnimationFrame(() => ajustar($item));
  });

  $(window).on('resize', function () {
    if (!mq.matches) return;
    $('header .tb-megamenu-item:hover').each(function () {
      ajustar($(this));
    });
  });
})(jQuery);


// MENU FIXADO NO TOP
(function ($) {
    const mq = window.matchMedia('(min-width: 1025px)');
    if (mq.matches) return;

    $('.site-header-fix .tb-megamenu-main .container > button').on('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        $('header .tb-megamenu-main .container > button').trigger('click');

    })
})(jQuery);